<div class="head primary-bg-color" [ngClass]="{'green': color === 'green', 'disabled': disabled}" (click)="barClick($event)">
    <div class="title font-large">{{title}}</div>
    <ion-button *ngIf="isButton" class="choose-new-coach" slot="end"
                [ngClass]="{disabled: isButtonDisabled || disabled}"
                (click)="buttonClick($event)">{{'__COACHING_JOURNEY_BOX2_CHOOSE_NEW_COACH__' | translate}}</ion-button>
    <img src="assets/img/plus-white.svg" alt="plus" *ngIf="!opened" [ngClass]="{'active': !disabled}">
    <img src="assets/img/minus-white.svg" alt="minus" *ngIf="opened" [ngClass]="{'active': !disabled}">
</div>
<div class="dropdown-box-content font-larger" [ngClass]="{'active': opened}">
    <ng-content></ng-content>
</div>
